import {addYears} from 'date-fns';
import {setCookie} from 'nookies';

const languageKey = 'NEXT_LOCALE';

const setLanguageCookie = (language: string, ctx?: any) => {
  setCookie(ctx, languageKey, language, {httpOnly: false, expires: addYears(new Date(), 5), path: '/'});
};

export default setLanguageCookie;
